// extracted by mini-css-extract-plugin
export var displayNone = "_u1-6";
export var imgContainer = "_u1-2";
export var overflowHidden = "_u1-3";
export var productInfoCardButtonContainer = "_u1-5";
export var productTitleText = "_u1-4";
export var rightArrow = "_u1-1";
export var rightArrowContainer = "_u1-0";